export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-05.3ed0f7ca.jpg";